<template>
  <form class="needs-validation ml-0" novalidate @submit.prevent="submit">
    <h1 class="h2 mb-3">Committee Affiliation Application</h1>
    <div class="text-center p-2" v-if="isLoading">
      <div class="spinner-border text-primary" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
    <div v-if="!isLoading">
      <div role="alert" class="alert alert-warning" v-if="errors.length">
        <div v-for="error in errors">{{ error }}</div>
      </div>
      <div role="alert" class="alert alert-warning" v-if="submitStatus === 'ERROR'">
        Please fill the form correctly.
      </div>
      <div role="alert" class="alert alert-warning" v-if="errorStatus">
        {{ errorStatus }}
      </div>
      <div><b>Paying for Season: </b> January 1, {{ this.$store.state.currentDate ? new Date(this.$store.state.currentDate).getFullYear() : new Date().getFullYear() }} to December 31, {{ this.$store.state.currentDate ? new Date(this.$store.state.currentDate).getFullYear() : new Date().getFullYear() }}</div>
      <br>
      <div role="alert" class="alert alert-info">
        Please note you should have the address filled in on your profile to complete the affiliation fee payment.
        Make sure you have the address saved before you proceed.
      </div>

      <div class="affiliation-form-wrapper">
        <h3>Committee Affiliation Form</h3>
        <div class="row block">
          <div class=" col-12 col-md-6 form-group">
            <label for="committeeName">Committee Name <span class="text-danger">*</span></label>
            <input type="text" class="form-control" :class="{ 'is-invalid': $v.data.name.$error || errorFields.name}"
                   id="committeeName"
                   required
                   v-model.trim="$v.data.name.$model">
            <div class="invalid-tooltip">Committee name must contain letters and spaces only.</div>
          </div>

          <div class="col-12 col-md-6 form-group">
            <label for="mailingAddress">Mailing Address <span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="mailingAddress"
                   :class="{ 'is-invalid': $v.fields.mailing_address.$error }"
                   required
                   v-model.trim="$v.fields.mailing_address.$model">
            <div class="invalid-tooltip" v-if="!$v.fields.mailing_address.required">Please include the Mailing Address.
            </div>

          </div>
        </div>

        <div class="row">
          <div class=" col-12 col-md-6 form-group">
            <label for="committeeSuburb">Suburb <span class="text-danger">*</span></label>
            <input type="text" class="form-control" :class="{ 'is-invalid': $v.fields.suburb.$error }"
                   id="committeeSuburb"
                   required
                   v-model.trim="$v.fields.suburb.$model">
            <div class="invalid-tooltip">Please include the Suburb.</div>
          </div>

          <div class="col-6 col-md-3 form-group">
            <label>State <span class="text-danger">*</span></label>
            <select class="form-control" required :class="{ 'is-invalid': $v.data.state.$error }"
                    v-model.trim="$v.data.state.$model">
              <option disabled></option>
              <option value="QLD">Queensland</option>
              <option value="NSW">New South Wales</option>
              <option value="VIC">Victoria</option>
              <option value="ACT">Australian Capital Territory</option>
              <option value="SA">South Australia</option>
              <option value="NT">Northern Territory</option>
              <option value="WA">Western Australia</option>
              <option value="TAS">Tasmania</option>
            </select>
            <div class="invalid-tooltip">Please include the State.</div>
          </div>

          <div class="col-6 col-md-3 form-group">
            <label for="CommitteePostcode">Postcode <span class="text-danger">*</span></label>
            <input type="text" class="form-control" id="CommitteePostcode" maxlength="4" required pattern="\d{4}"
                   :class="{ 'is-invalid': $v.data.post_code.$error }"
                   v-model.trim="$v.data.post_code.$model">
            <div class="invalid-tooltip">Please include a four-digit Postcode.</div>
          </div>
        </div>
      </div>

      <div class="row block">
        <div class="col-12 col-md-6 form-group">
          <label for="committeeGroundsAddress">Campdraft Grounds Address <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="committeeGroundsAddress"
                 :class="{ 'is-invalid': $v.fields.grounds_address.$error }"
                 required v-model.trim="$v.fields.grounds_address.$model">
          <div class="invalid-tooltip">Please include Campdraft Grounds Address.</div>
        </div>

        <div class="col-12 col-md-6 form-group">
          <label for="committeeGroundsAddressSuburb">Suburb <span class="text-danger">*</span></label>
          <input type="text" class="form-control" id="committeeGroundsAddressSuburb"
                 :class="{ 'is-invalid': $v.fields.grounds_suburb.$error }"
                 required v-model.trim="$v.fields.grounds_suburb.$model">
          <div class="invalid-tooltip">Please include the Suburb.</div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 form-group">
          <label>State <span class="text-danger">*</span></label>
          <select class="form-control" required
                  :class="{ 'is-invalid': $v.fields.grounds_state.$error }"
                  v-model.trim="$v.fields.grounds_state.$model">
            <option disabled></option>
            <option value="QLD">Queensland</option>
            <option value="NSW">New South Wales</option>
            <option value="VIC">Victoria</option>
            <option value="ACT">Australian Capital Territory</option>
            <option value="SA">South Australia</option>
            <option value="NT">Northern Territory</option>
            <option value="WA">Western Australia</option>
            <option value="TAS">Tasmania</option>
          </select>
          <div class="invalid-tooltip">Please include the State.</div>
        </div>

        <div class="col-12 col-md-6 form-group">
          <label>Postcode <span class="text-danger">*</span></label>
          <input type="text" class="form-control" maxlength="4" required
                 pattern="\d{4}"
                 :class="{ 'is-invalid': $v.fields.grounds_postcode.$error }"
                 v-model.trim="$v.fields.grounds_postcode.$model">
          <div class="invalid-tooltip">Please include a four-digit Postcode.</div>
        </div>
      </div>

      <div class="row block">
        <div class="col-12 col-md-6 form-group">
          <label>President Name</label>
          <input
            type="text"
            class="form-control"
            v-model.trim="$v.fields.president_name.$model"
          >
        </div>

        <div class="col-12 col-md-6 form-group">
          <label>Secretary Name</label>
          <input
            type="text"
            class="form-control"
            v-model.trim="$v.fields.secretary_name.$model"
          >
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 form-group">
          <label>Treasurer Name</label>
          <input
            type="text"
            class="form-control"
            v-model.trim="$v.fields.treasurer_name.$model"
          >
        </div>

        <div class="col-12 col-md-6 form-group">
          <label>Other Name: (Campdraft Steward etc)</label>
          <input
            type="text"
            class="form-control"
            v-model.trim="$v.fields.other_name.$model"
          >
        </div>
      </div>

      <div class="row block">
        <div class="col-12 col-md-6 form-group">
          <b style="font-size: 18px;">At your campdraft grounds, does the committee have access to: </b>
        </div>
      </div>

      <div class="row" style="padding-bottom: 20px;">
        <div class="col-3 col-md-2 form-group">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="internet_access"
                   v-model.trim="$v.fields.internet_access.$model">
            <label class="custom-control-label access-to" for="internet_access">
              Internet access
            </label>
            <div class="invalid-tooltip">Please include true or false.</div>
          </div>
        </div>
        <div class="col-3 col-md-2 form-group">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="phone_service"
                   v-model.trim="$v.fields.phone_service.$model">
            <label class="custom-control-label access-to" for="phone_service">
              Phone service
            </label>
            <div class="invalid-tooltip">Please include true or false.</div>
          </div>
        </div>
      </div>

      <div v-for="(v, index) in $v.fields.drafts.$each.$iter">
        <div class="row">
          <div class="col-6 col-md-3 form-group">
            <label>Proposed Campdraft Start Date</label>
            <input type="date" class="form-control form-date" maxlength="4" required
                   :class="{ 'is-invalid': v.start.$error }"
                   v-model.trim="v.start.$model" :placeholder="'dd.mm.yyyy'"
                   pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}">

            <div class="invalid-tooltip">Please include the Proposed Campdraft Start Date.</div>
          </div>
          <div class="col-6 col-md-3 form-group">
            <label>Proposed Campdraft End Date</label>
            <input type="date" class="form-control form-date" maxlength="4" required
                   :class="{ 'is-invalid': v.end.$error }"
                   v-model.trim="v.end.$model" :placeholder="'dd.mm.yyyy'"
                   pattern="[0-9]{4}-[0-9]{2}-[0-9]{2}">

            <div class="invalid-tooltip">Please include the Proposed Campdraft End Date.</div>
          </div>
          <div class="col-1 col-md-1 form-group button-remove-draft" v-if="index != 0"
               @click="fields.drafts.splice(index, 1)">
            ✕
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-6 col-offset-1 form-group right-end">
          <button class="btn btn-block mb-2 btn-primary button-add-draft" @click="addDraft" type="button">Add One More
            Draft
          </button>
        </div>
      </div>
      <div class="row">
        <div class="col-12 col-md-6 form-group">
          <div class="custom-control custom-checkbox">
            <input type="checkbox" class="custom-control-input" id="event_membership_agree"
                  v-model.trim="$v.fields.event_membership_agree.$model">
            <label class="custom-control-label access-to" for="event_membership_agree">
              By checking this box, your committee consents to receiving an invoice for Event Membership Fees
              collected on behalf of ACA, if your committee chooses to accept Casual Members.
            </label>
            <div class="invalid-tooltip">Please include true or false.</div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-4 form-group save-details-button">
          <button class="btn btn-block mb-2 btn-primary" :disabled="submitStatus == 'PENDING' || !fields.event_membership_agree" type="button"
                  @click.prevent="handleShowModal">
            <div class="spinner-border" role="status" v-if="submitStatus == 'PENDING'">
              <span class="sr-only">Loading...</span>
            </div>
            <div v-if="submitStatus != 'PENDING' || !submitStatus">Check Out</div>
          </button>
        </div>
      </div>
      <div class="row">
        <img src="/static/img/checkout.png" style="max-width: 250px;" class="px-3"/>
      </div>
    </div>

    <modal v-if="showModal" @close="showModal = false">
      <div slot="body">
          <div class="text">
            <h4><b>Season Confirmation</b></h4>
          </div>
          <div class="text pt-3">
            <b class="pr-2">Please confirm your selected season: </b> <span
            class="badge badge-danger">{{ new Date(this.$store.state.currentDate).getFullYear() }}</span>
          </div>
          <div class="text pt-3">Note: The ACA Financial/Membership Year runs <br> from 1 January to 31 December.</div>
      </div>
      <div slot="footer">
        <div class="col-12 d-flex justify-content-center" v-if="submitStatus != 'PENDING' || !submitStatus">
          <button class="btn btn-outline-primary ml-2" @click.prevent="showModal = false">Cancel</button>
          <button class="btn btn-primary ml-2" @click.prevent="submit">Confirm</button>
        </div>
        <div class="text-center p-2" v-if="submitStatus == 'PENDING'">
          <div class="spinner-border text-primary" role="status">
            <span class="sr-only">Loading...</span>
          </div>
        </div>
      </div>
    </modal>

  </form>

</template>

<script>

import axios from "axios"
import { helpers, required } from 'vuelidate/lib/validators'
import Vue from 'vue'
import Vuelidate from 'vuelidate'
import modal from '@/components/Modal'

const nameRegex = helpers.regex('name', /^[A-Za-z\s]*$/)

Vue.use(Vuelidate)

export default {
  name: 'CommitteeAffiliationForm',
  props: ['secretary', 'committeeDetails', 'isLoading'],
  components: {
    modal
  },
  data() {
    return {
      showModal: false,
      errors: [],
      errorStatus: null,
      fields: {
        committee_id: '',
        mailing_address: '',
        suburb: '',
        drafts: [{
          start: '',
          end: ''
        }],
        grounds_address: '',
        grounds_suburb: '',
        grounds_state: '',
        grounds_postcode: '',
        president_name: '',
        secretary_name: '',
        treasurer_name: '',
        other_name: '',
        internet_access: '',
        phone_service: '',
        event_membership_agree: false
      },
      data: {
        affiliation_id: '',
        is_invoice_created: '',
        post_code: '',
        state: '',
        name: ''
      },
      submitStatus: null,
      hasOnlinePayments: false,
      errorFields: {}
    }
  },
  validations() {
    const validationRules = {
      fields: {
        mailing_address: {
          required
        },
        suburb: {
          required
        },
        drafts: {
          $each: {
            start: {},
            end: {}
          }
        },
        grounds_address: { required },
        grounds_suburb: { required },
        grounds_state: { required },
        grounds_postcode: { required },
        president_name: {},
        secretary_name: {},
        treasurer_name: {},
        other_name: {},
        internet_access: {},
        phone_service: {},
        event_membership_agree: {
          required
        }
      },
      data: {
        state: {
          required
        },
        post_code: {
          required
        },
        name: {
          required,
          nameRegex
        }
      }
    }
    return validationRules
  },
  watch: {
    committeeDetails() {
      this.data = { ...this.committeeDetails }
      this.fields.committee_id = this.committeeDetails.id
      this.prefillAffiliationFormData()
    }
  },
  methods: {
    handleShowModal() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        this.submitStatus = 'OK'
        this.showModal = true
      }
    },
    prefillAffiliationFormData() {
      const currentAffiliation = this.committeeDetails.current_affiliation
      if (currentAffiliation) {
        this.data.affiliation_id = currentAffiliation.id
        this.data.is_invoice_created = currentAffiliation.is_invoice_created
        this.fields.committee_id = currentAffiliation.committee_id
        this.fields.mailing_address = currentAffiliation.mailing_address
        this.fields.suburb = currentAffiliation.suburb
        this.fields.grounds_address = currentAffiliation.grounds_address
        this.fields.grounds_suburb = currentAffiliation.grounds_suburb
        this.fields.grounds_state = currentAffiliation.grounds_state
        this.fields.grounds_postcode = currentAffiliation.grounds_postcode
        this.fields.president_name = currentAffiliation.president_name
        this.fields.drafts = JSON.parse(currentAffiliation.drafts)
        this.fields.secretary_name = currentAffiliation.secretary_name
        this.fields.treasurer_name = currentAffiliation.treasurer_name
        this.fields.other_name = currentAffiliation.other_name
        this.fields.internet_access = currentAffiliation.internet_access === 1
        this.fields.phone_service = currentAffiliation.phone_service === 1
        this.fields.event_membership_agree = currentAffiliation.event_membership_agree
      }
    },
    addDraft() {
      this.fields.drafts.push({
        start: '',
        end: ''
      })
    },
    async submit() {
      this.$v.$touch()
      if (this.$v.$invalid) {
        this.submitStatus = 'ERROR'
      } else {
        // do your submit logic here
        this.submitStatus = 'PENDING'

        const mergedData = { ...this.data, ...this.fields }
        const formData = new FormData()
        formData.append('fields', JSON.stringify(mergedData))
        const result = await axios.post(`${this.$api}/committee/affiliation`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        if (result.data.status === 'success') {
          const product = this.$store.state.products.find(item => item.type === 'Committee' && item.active === 1)
          axios.post(`${this.$api}/total-cart`, { data: [product.id], user_id: this.secretary.id }).then((response) => {
            if (response.data.status === 'success') {
              const committeeData = { committee: this.committeeDetails, ...response.data, secretary: { id: this.secretary.id, email: this.secretary.attributes.email, member_number: this.secretary.member_number } }
              this.$store.commit('updateCartMembers', committeeData)
              this.$router.push({ name: 'Committee Cart', params: { backTo: 'pay' } })
              this.submitStatus = 'SUCCESS'
            }
          }).catch((error) => {
            this.processing = false
            // eslint-disable-next-line
            console.log(error)
          })
        } else if (result.data.errors.name !== undefined) {
          this.errorStatus = result.data.errors.name[0]
          this.errorFields.name = true
        } else {
          this.submitStatus = 'OK'
          this.errorStatus = 'Something went wrong. Please try again.'
          this.showModal = false
        }
        this.processing = false
      }
    }
  }
}
</script>

<style scoped>

.save-details-button {
  max-width: 250px;
  padding-top: 25px;
}

.download-blank {
  max-width: 230px;
}

.block {
  padding-top: 20px;
}

.access-to {
  font-weight: 500 !important;
}

.button-add-draft {
  max-width: 230px;
}

.right-end {
  display: flex;
  justify-content: end;
}

@media screen and (max-width: 768px) {

  .right-end {
    display: flex;
    justify-content: center;
  }
}

.button-remove-draft {
  padding-top: 30px;
  display: flex;
  align-items: center;
  color: var(--primary-dark);
  cursor: pointer;
}

.text {
  display: flex;
  justify-content: center;
  text-align: center;
}

.badge-danger {
  background-color: var(--primary);
}
</style>



// WEBPACK FOOTER //
// src/views/Committees/Affiliation/components/CommitteeAffiliationForm.vue